<template>
    <div>
        <div class="loading">
            <span>&bull;</span><span>&bull;</span><span>&bull;</span>
        </div>
        <h2>Please close this window to continue.</h2>
    </div>
</template>

<script>
export default {
    mounted() {
        window.opener.access_code = this.$route.query.code;
        window.close();
    }
};
</script>
